module.exports = __webpack_public_path__ + "img/headservice.1efcd964.png";